import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    maxLength
} from "vuelidate/lib/validators";
import axios from "axios";
import $ from "jquery";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "createCategory",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            id: "",
            name: "",
            category_image: "",
            submitted: false
        };
    },

    validations: {
        name: {
            required,
            maxLength: maxLength(100)
        },
        category_image: {
            required
        }
    },

    methods: {
        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return null;
            this.category_image = e.target.files[0];
            let reader = new FileReader();
            reader.onload = e => {
                this.category_image = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        submit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.categoryCreate();
        },

        categoryCreate() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            var request;
            if (this.category_image.length < 10000000) {
                request = {
                    category_name: this.name,
                    category_image: this.category_image
                };
            } else {
                request = {
                    category_name: this.name,
                    category_image: null
                };
            }
            
            axios.post("/category/create", request)
                .then(response => {
                    $("#block-btn").attr("disabled", false);
                    if (response.data.error_msg) {
                        this.image_size = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("The upload image size is too large.", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.success("Category Added Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.isLoading = false;
                        this.$router.push({
                            name: "categoryList"
                        });
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$notification.error("Category Adding Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("categoryCreate Error", error.errors);
                });
        }
    }
};